import React from "react";
import { FaMinus, FaPlus, FaSave, FaWeight } from "react-icons/fa";

function QuickWeightCard({ value, onChange, onAdjust, onSave, saving, t }) {
  return (
    <div className="rounded-[1.35rem] border border-orange-200 bg-orange-50 p-4 shadow-sm dark:border-orange-400/20 dark:bg-orange-500/10">
      <div className="flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-orange-100 text-orange-700 dark:bg-orange-500/10 dark:text-orange-200">
          <FaWeight />
        </div>

        <div className="min-w-0 flex-1">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-orange-700 dark:text-orange-200">
            {t("judokaProfile.weight", { defaultValue: "Poids" })}
          </p>

          <div className="mt-3 flex items-center gap-2">
            <button
              type="button"
              onClick={() => onAdjust(-0.5)}
              disabled={saving}
              className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-orange-200 bg-white text-orange-700 transition hover:-translate-y-0.5 hover:shadow-md disabled:cursor-not-allowed disabled:opacity-60 dark:border-orange-400/20 dark:bg-white/10 dark:text-orange-200"
              aria-label="Diminuer le poids"
            >
              <FaMinus className="text-xs" />
            </button>

            <div className="relative flex-1">
              <input
                type="number"
                value={value}
                onChange={(event) => onChange(event.target.value)}
                min="0"
                step="0.1"
                className="min-h-11 w-full rounded-2xl border border-orange-200 bg-white px-4 py-2 pr-10 text-center text-base font-bold text-slate-950 outline-none transition focus:border-orange-400 focus:ring-4 focus:ring-orange-500/10 dark:border-orange-400/20 dark:bg-white/10 dark:text-white"
                placeholder="--"
              />

              <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-sm font-bold text-slate-400">
                kg
              </span>
            </div>

            <button
              type="button"
              onClick={() => onAdjust(0.5)}
              disabled={saving}
              className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-orange-200 bg-white text-orange-700 transition hover:-translate-y-0.5 hover:shadow-md disabled:cursor-not-allowed disabled:opacity-60 dark:border-orange-400/20 dark:bg-white/10 dark:text-orange-200"
              aria-label="Augmenter le poids"
            >
              <FaPlus className="text-xs" />
            </button>
          </div>

          <button
            type="button"
            onClick={onSave}
            disabled={saving}
            className="mt-3 inline-flex min-h-10 w-full items-center justify-center gap-2 rounded-2xl bg-slate-950 px-4 py-2 text-sm font-bold text-white transition hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-white dark:text-slate-950"
          >
            <FaSave className="text-xs" />
            {saving ? "Mise à jour..." : "Mettre à jour le poids"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default QuickWeightCard;